import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { useAuthStore } from '@/stores/auth-store'
import { type SliceKey, useListStateStore } from '@/stores/list-state-store'

function matchesRoute(pathname: string, route: string): boolean {
  return pathname === route || pathname.startsWith(route + '/')
}

function getActiveSlice(pathname: string): SliceKey | undefined {
  // Checked before /admin/loyalty, which would otherwise claim them.
  if (matchesRoute(pathname, '/admin/loyalty/incentive-tiers')) return 'loyaltyIncentiveTiers'
  if (matchesRoute(pathname, '/admin/loyalty/ranks')) return 'loyaltyRanks'
  if (matchesRoute(pathname, '/admin/loyalty')) return 'loyaltyCustomers'
  if (matchesRoute(pathname, '/admin/pos-users')) return 'posUsers'
  if (matchesRoute(pathname, '/admin/promotions')) return 'promotions'
  if (matchesRoute(pathname, '/operations/users')) return 'users'
  return undefined
}

export function useListStateReset(): void {
  const { pathname } = useLocation()
  const selectedSystem = useAuthStore((s) => s.selectedSystem)
  const prevPathRef = useRef(pathname)
  const prevSystemRef = useRef(selectedSystem)

  useEffect(() => {
    const { resetSlice, resetAllSlices } = useListStateStore.getState()

    if (prevSystemRef.current !== selectedSystem) {
      prevSystemRef.current = selectedSystem
      resetAllSlices()
      prevPathRef.current = pathname
      return
    }

    const prevSlice = getActiveSlice(prevPathRef.current)
    const currentSlice = getActiveSlice(pathname)
    prevPathRef.current = pathname

    if (prevSlice && prevSlice !== currentSlice) {
      resetSlice(prevSlice)
    }
  }, [pathname, selectedSystem])
}
